export enum TextType {
  Bot = 'bot',
  Self = 'self',
  Event = 'event',
  Other = 'other',
}
